import http from "./http";
import { API_BASE_URL } from "../config";

export default class PassengerService {
  static getPassenger() {
    return http
      .get(`${API_BASE_URL}/v2/passengers`)
      .then((response) => response.data);
  }
  static getPassengerPg(page,limit,searchQuery={}) {
    const config = {
      params:{
        page,
        limit,
        ...searchQuery,
      }
    }
    
    return http
      .get(`${API_BASE_URL}/v2/passengers`,config)
      .then((response) => response.data);
  }

  static updateRideShareAccess(passengerId, enabled) {
    return http
      .patch(
        `${API_BASE_URL}/v2/admin/passengers/${passengerId}/rideshare-access`,
        {
          enabled,
        },
      )
      .then((response) => response.data);
  }

  static getGlobalRideShareAccess() {
    return http
      .get(`${API_BASE_URL}/v2/admin/rideshare-access/passenger`)
      .then((response) => response.data);
  }

  static updateGlobalRideShareAccess(enabled) {
    return http
      .patch(`${API_BASE_URL}/v2/admin/rideshare-access/passenger`, {
        enabled,
      })
      .then((response) => response.data);
  }

}
